export class DefenderForCloudConstants {
  public static PlaceholdersAndTitles = {
    DefenderForCloud: 'Defender For Cloud',
    BasicInformation: 'BASIC INFORMATION',
    ActionTitlePlaceholder: 'The title will be automatically generated once a MACC Opportunity ID is entered',
    RequestorInformation: 'REQUESTOR INFORMATION',
    AdditionalInformation: 'ADDITIONAL INFORMATION',
    OppurtunityInformation: 'OPPORTUNITY INFORMATION',
    AEAlias: 'AE Alias',
    CEAlias: 'CE Alias',
    SSNPAlias: 'SSSP Alias',
    AEName: 'Account Executive Name',
    CEName: 'Commercial Executive Name',
    SSSPName: 'Services Seller Name',
    SSNPName: 'Security Specialist Name',
    RemoveAEAlias: 'remove Accountable Exec',
    CustomerName: 'Customer Name',
    EnterCustomerName: 'Enter Customer Name',
    OpportunityRevenueSize: 'MACC Opportunity Revenue Size (USD)',
    EnterOpportunityRevenueSize: 'Enter MACC Opportunity Revenue Size',
    DurationInMonths: 'MACC Duration in Months',
    EnterDurationInMonths: 'Enter MACC Duration in Months',
    AnnualizedValue: 'Annualized MACC Value (USD)',
    OperationgUnit: 'Operating Unit',
    ExpectedMinimumSupportAdoption: 'Expected Minimum Unified Adoption %',
    ProposedSupportAdoption: 'Proposed Defender for Cloud Attach % to Total Revenue Opportunity Size',
    ProposedSupportAdoptionInfo:
      'Please use the Defender For Cloud Estimator tool to determine Minimum Unified Adoption %',
    PurpleEstimator: 'Defender For Cloud Estimator',
    PurpleEstimatorInfo:
      'Please use the Defender For Cloud Estimator tool to determine Proposed Unified Adoption %',
    ReasonforException: 'Reason for Exception',
    ConfirmSupportConsultStage:
      'Was the security seller engaged during the Listen & Consult phase for this MACC / M&M opportunity?',
    CustomerSupportAdoption:
      "How does the customer plan to protect their cloud resources?",
    UnifieldAdoption:
      "How will the Consumption Plan will be successfully executed without a cloud security strategy for their cloud architecture?",
    ExceptionApprover: 'Exception Approver (AVP)',
    RemoveExceptionApprover: 'Remove Exception Approver',
    Notificationsent: 'Stakeholder(s) to be notified',
    OptionalAreaSupportLead: 'Optional Area Support Lead',
    EnterValue: 'Enter Value',
    EnterTextHere: 'Enter text here',
    RemoveRequestor: 'Remove Requestor',
    select: 'Select',
    SelectReasonForException: 'Select Reason for Exception',
    RequestorManager: "Requestor's Manager",
    AEAliasMandatory: 'AE Name is mandatory',
    RemoveCEAlias: 'Remove CE Alias',
    RemoveSSSPAlias: 'Remove SSSP Alias',
    ExceptionApproverMandatory: 'Exception Approver is mandatory',
    NotificationSentMandatory: 'Notification Sent is/are mandatory',
    Attachments: 'Attachments',
    AttachmentsInfo:
      'Please include a copy of the Defender For Cloud Estimator for this deal, as well as any other relevant attachments.',
    OppID: 'Opportunity ID',
    OpportunityName: 'Opportunity Name',
    EnterOpportunityID: 'Enter Opportunity ID',
    EnterOpportunityName: 'Enter Opportunity Name',
    TPID: 'TPID',
    EnterTPID: 'Enter TPID',
    Requestors: 'Requestor(s)',
    Requestor: 'Requestor',
    Country: 'Country',
    SelectCountry: 'Select Country',
    EnterOperatingUnit: 'Enter Operating Unit',
    NotificationSent: 'Stakeholder(s) to be notified',
    CustomerUnifiedAgreement: 'Does customer have an existing Unified Agreement?',
    ProposedUnifiedContractRevenue: 'Proposed Defender for Cloud Revenue (USD)',
    EnterProposedUnifiedContractRevenue: 'Enter Proposed Defender for Cloud Revenue',
    ProposedDefenderForCloudFYRevenue: 'Defender for Cloud Current FY Revenue (USD)',
    EnterProposedUnifiedDurationInMonths: 'Enter Defender for Cloud Current FY Revenue',
    AnnualizedUnifiedRevenue: 'Annualized Unified Revenue',
    ProposedUnifiedRevenue: 'Proposed Unified Revenue',
    EnterProposedUnifiedRevenue: 'Enter Proposed Unified Revenue',
    OtherReasonForException: 'Provide details for selecting "Other"',
    EnterOtherReasonForException: 'Enter Other Reason for Exception',
  };

  public static TabPath = '&tab=DefenderForCloud';

  public static UATFields = {
    // Standard fields
    Account: 'Custom.Account',
    Title: 'System.Title',
    AssignedTo: 'System.AssignedTo',
    State: 'System.State',
    AreaPath: 'System.AreaPath',
    SubState: 'Custom.SubState',
    Requestor: 'Custom.Requestor',
    Requestors: 'Custom.Requestors',
    Country: 'Custom.UATCountry',
    OpportunityId: 'Custom.Opportunity_ID',
    OpportunityName: 'Custom.OpportunityName',
    Opportunity_Size: 'Custom.Opportunity_Size',
    TPID: 'Custom.TPID',
    AccountId: 'Custom.AccountId',
    NodeName: 'System.NodeName',
    // DEF specific fields
    DEF_AE_Alias: 'Custom.DEF_AE_Alias',
    DEF_CE_Alias: 'Custom.DEF_CE_Alias',
    DEF_SSNP_Alias: 'Custom.DEF_SSNP_Alias',
    DEF_Duration_in_Months: 'Custom.DEF_Duration_in_Months',
    DEF_ExpectedMinSupport_Adoption: 'Custom.DEF_ExpectedMin_Support_Adoption',
    DEF_Proposed_Support_Adoption: 'Custom.DEF_Proposed_Support_Adoption',
    DEF_Operating_Unit: 'Custom.DEF_Operating_Unit',
    DEF_Annualized_Value: 'Custom.DEF_Annualized_Value',
    DEF_Proposed_Unified_Contract_Revenue: 'Custom.DEF_Proposed_Unified_Contract_Revenue',
    DEF_Proposed_UnifiedRevenue: 'Custom.DEF_Proposed_UnifiedRevenue',
    DEF_Proposed_Unified_Duration_in_Months: 'Custom.DEF_Proposed_Unified_Duration_In_Months',
    DEF_Annualized_Unified_Revenue: 'Custom.DEF_Annualized_Unified_Revenue',
    DEF_Reason_for_Exception: 'Custom.DEF_Reason_for_Exception',
    DEF_Exception_Approver: 'Custom.DEF_Exception_Approver',
    DEF_Notification_Tobe_Sent: 'Custom.DEF_Notification_tobe_sent',
    DEF_Optional_Area_Support_Lead: 'Custom.DEF_Optional_Area_Support_Lead',
    DEF_IS_Sales_Engaged: 'Custom.DEF_IS_Sales_Engaged',
    Def_Customer_Existing_Cloud: 'Custom.Def_Customer_Existing_Cloud',
    DEF_Customers_Current_Support_Adoption: 'Custom.DEF_Customers_current_Support_adoption',
    DEF_Consumption_Plan: 'Custom.DEF_Consumption_Plan',
    DEF_Requestor_Manager: 'Custom.DEF_Requestor_Manager',
    DEF_TPID: 'Custom.DEF_TPID',
    DEF_Customer_Name: 'Custom.DEF_Customer_Name',
    DEF_Country: 'Custom.DEF_Country',
    DEF_Opportunity_Revenue_Size: 'Custom.DEF_Opportunity_Revenue_Size',
    DEF_Other: 'Custom.DEF_Other',
  };

  public static ErrorMessages = {
    ExpectedMinimumSupportAdoptionMandatory: 'Expected Minimum Unified Adoption is mandatory',
    ProposedSupportAdoptionMandatory: 'Proposed Support Adoption is mandatory',
    ExpectedMinimumSupportAdoptionNumeric: 'Expected Minimum Unified Adoption is mandatory',
    ProposedSupportAdoptionNumeric: 'Proposed Support Adoption is mandatory',
    ReasonForExceptionMandatory: 'Reason for Exception is mandatory',
    OtherReasonForExceptionMandatory: 'This field is mandatory when Other is selected',
    OpportunityMandatory: 'Opportunity ID is mandatory',
    InvalidOpportunityID: 'Invalid Opportunity ID',
    ExceptionApproverMandatory: 'Exception Approver is mandatory',
    IsSalesEngagedMandatory: 'Sales Engaged confirmation is mandatory',
    CustomerUnifiedAgreementMandatory: 'Customer Unified Agreement is mandatory',
    ConsumptionPlanMandatory: 'Consumption Plan is mandatory',
    SupportAgreementMandatory: 'Support Agreement is mandatory',
    RiskAssessmentMandatory: 'Risk Assessment is mandatory',
    AeAliasMandatory: 'Account Executive alias is mandatory',
  };

  public static AnnualizedValues: { [key: number]: number } = {
    500000: 12,
    5000000: 11,
    15000000: 10,
    30000000: 8,
    50000000: 7,
    100000000: 4,
  };
}
